import { render, staticRenderFns } from "./iconbase.vue?vue&type=template&id=b386e968&scoped=true&"
import script from "./iconbase.vue?vue&type=script&lang=js&"
export * from "./iconbase.vue?vue&type=script&lang=js&"
import style0 from "./iconbase.vue?vue&type=style&index=0&id=b386e968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b386e968",
  null
  
)

export default component.exports